export const getPaginationDetails=(currentPage,totalItems,limit)=>{
    let itemsPerPage
    if(limit){
        itemsPerPage = limit;
    }else{
        itemsPerPage=10
    }
    const toatlPage=totalItems/10
    const startIndex = (currentPage - 1) * itemsPerPage + 1;
    const endIndex=Math.min(currentPage * itemsPerPage, totalItems);
    const paginationMessage = `${startIndex}-${endIndex} of ${totalItems}`;
    return paginationMessage
}